<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingClientList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="50"
            :footer-props="footerProps"
            :options.sync="options"
            :server-items-length="totalClientCount"
            :search="searchClientString"
            class="product-table"
            dense
            :headers="clientTableHeaders"
            :items="clients"
        >
            <template v-for="h in clientTableHeaders" v-slot:[`header.${h.value}`]="{ header }">
                <span :class="'text-' + header.align">{{ header.text ? t(header.text) : "-" }}</span>
            </template>
            <template v-slot:item="{ item }">
                <tr
                    :key="'contact_' + item.id"
                    @click="handleTableRowClick(item)"
                    :class="{
                        activeTableRow: activeClient && parseInt(item.id) === parseInt(activeClient.id)
                    }"
                >
                    <td
                        v-for="(row, index) in clientTableHeaders"
                        :class="{
                            lastColumn: index === clientTableHeaders.length - 1 && clientTableHeaders.length > 2,
                            penultimateColumn: index === clientTableHeaders.length - 2 && clientTableHeaders.length > 2
                        }"
                    >
                        <span v-if="row.value === 'flag'"
                            ><country-flag v-if="item.country_code" :country="item.country_code" size="small"
                        /></span>
                        <span v-else-if="row.value === 'country'">{{ getItemCountry(item) }}</span>
                        <span v-else>{{ item[row.value] ? item[row.value] : "-" }}</span>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import Store from "@/store";
import { mapState, mapGetters } from "vuex";
import CountryFlag from "vue-country-flag";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "client-list",
    components: {
        CountryFlag
    },
    data() {
        return {
            footerProps: { "items-per-page-options": [25, 50, 100] },
            options: this.tableOptions
        };
    },
    mounted() {
        //Store.dispatch("ClientStore/callGetClientsList");
    },
    computed: {
        ...mapState("ClientStore", [
            "searchClientString",
            "loadingClientList",
            "activeClient",
            "clients",
            "tableOptions",
            "clientTableHeaders",
            "totalClientCount"
        ]),
        ...mapState(["user"]),
        ...mapGetters("ClientStore", ["clientCount"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    watch: {
        options(val) {
            Store.commit("ClientStore/setTableOptions", val);
        }
    },
    methods: {
        handleTableRowClick(client) {
            if (!this.hasPermissionForAction(PermissionsConstants.CLIENT, PermissionsConstants.VIEW)) {
                return;
            }
            if (this.$route.name !== "client-view") {
                this.$router.push({ name: "client-view", params: { clientId: client.id } });

                return;
            }
            if (this.$route.name === "client-view" && parseInt(client.id) !== parseInt(this.$route.params.clientId)) {
                this.$router.push({ name: "client-view", params: { clientId: client.id } });
                Store.dispatch("ClientStore/getClientData", client.id);
            }
        },
        getItemCountry(item) {
            if (item.country_estonian) {
                return item.country_estonian;
            }
            if (item.country_english) {
                return item.country_english;
            }
            return "-";
        }
    }
};
</script>

<style scoped>
.lastColumn {
    text-align: center;
}
.penultimateColumn {
    text-align: end;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
